export const CREATE_ORG_TYPE = 'CREATE_ORGANIZATION';
